import { heading } from "../styles.js";

const Pill = ({ label: lbl, s, small }) => (
    <span
      className={`inline-flex items-center gap-1.5 ${small ? "px-2 py-0.5 text-[10px]" : "px-2.5 py-1 text-xs"} font-medium rounded-full ring-1 ${s.bg} ${s.text} ${s.ring || "ring-transparent"}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${s.dot}`} />
      {lbl}
    </span>
  );

const Ava = ({ name, photo, size = "md" }) => {
    const sz = {
      xs: "w-7 h-7 text-[10px] rounded-full",
      sm: "w-9 h-9 text-xs rounded-full",
      md: "w-11 h-11 text-sm rounded-full",
      lg: "w-16 h-16 text-base rounded-full",
      xl: "w-20 h-20 text-xl rounded-2xl",
    }[size];
    const initial = ((name || "?").trim()[0] || "?").toUpperCase();
    return (
      <div
        className={`${sz} overflow-hidden flex items-center justify-center font-semibold shrink-0 ring-1 ring-white/10 bg-gradient-to-br from-amber-200/20 to-amber-200/5 text-amber-100`}
        style={heading}
      >
        {photo ? (
          <img
            src={photo}
            loading="lazy"
            decoding="async"
            className="w-full h-full object-cover"
            alt=""
          />
        ) : (
          initial
        )}
      </div>
    );
  };

const Spinner = ({ size = 16 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" className="animate-spin">
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
        opacity=".25"
      />
      <path
        d="M22 12a10 10 0 0 1-10 10"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
        strokeLinecap="round"
      />
    </svg>
  );

const YesNo = ({ value, onChange, disabled = false, title }) => (
    <div
      title={title}
      className={`inline-flex w-full rounded-lg bg-white/[0.04] border border-white/[0.08] p-0.5 ${disabled ? "opacity-60 cursor-not-allowed [&>button]:pointer-events-none" : ""}`}
    >
      <button
        type="button"
        disabled={disabled}
        onClick={() => onChange(true)}
        className={`flex-1 py-1.5 text-sm rounded-md transition font-medium ${value ? "bg-emerald-400/20 text-emerald-200 ring-1 ring-emerald-400/30" : "text-slate-400 hover:text-slate-200"}`}
      >
        Yes
      </button>
      <button
        type="button"
        disabled={disabled}
        onClick={() => onChange(false)}
        className={`flex-1 py-1.5 text-sm rounded-md transition font-medium ${!value ? "bg-white/[0.08] text-slate-200 ring-1 ring-white/[0.12]" : "text-slate-400 hover:text-slate-200"}`}
      >
        No
      </button>
    </div>
  );

export { Pill, Ava, Spinner, YesNo };
